// components/GlobalReveal.jsx
import { useEffect } from "react";

export default function GlobalReveal({ children }) {
  useEffect(() => {
    const sections = document.querySelectorAll("section, .reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(
              "h1, h2, h3, p, img, li, .card, .reveal-item"
            );

            items.forEach((child, index) => {
              child.style.opacity = 0;
              child.style.transform = "translateY(30px)";
              setTimeout(() => {
                child.style.transition = "all 0.6s ease-out";
                child.style.opacity = 1;
                child.style.transform = "translateY(0)";
              }, index * 100); // stagger children
            });

            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return <>{children}</>;
}